import { ClipboardDocumentCheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { ReactNode } from "react";

import Headline from "~/components/Headline";
import { useCopyStyled } from "~/hooks/useCopyStyled.ts";

type Props = { children: ReactNode; };

const InvoiceNumberHeader = ({ children }: Props) => {
	const { copyToClipboard, copied, targetRef } = useCopyStyled({ includeFormatting: false });
	const ClipboardIcon = copied ? ClipboardDocumentCheckIcon:ClipboardDocumentIcon;
	return <button onClick={copyToClipboard}
				   className="group relative">
		<Headline type="h2">
			<div ref={targetRef}>{children}</div>
			<div className="absolute -right-6 top-0 hidden group-hover:block">
				<ClipboardIcon className={clsx("size-6", copied ? "text-success-600": "text-gray-500")} />
			</div>
		</Headline></button>;
};

export default InvoiceNumberHeader;